import { render, staticRenderFns } from "./EmailReset.vue?vue&type=template&id=43442aec"
import script from "./EmailReset.vue?vue&type=script&lang=js"
export * from "./EmailReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports